export const STORAGE = {
  AUTH_TOKEN: 'AUTH_TOKEN',
  PAGE_URL: 'PAGE_URL',
};
